import * as t from "io-ts"

export const TVersion = t.interface({
  backupSiteName: t.string,
  backupSiteUrl: t.string,
  version: t.string,
  siteName: t.string,
  handlingApplication: t.string,
  useHeaderAuth: t.boolean
})

export type Version = t.TypeOf<typeof TVersion>
